<!-- eslint-disable-next-line vue/no-v-html -->
<template>
  <section class="content map">

    <div class="map-wrapper" ref="gMapWrapper">
      <div v-if="map.message !== null"
           v-bind:class="'callout callout-'+map.message.type">
        <p>{{ map.message.text }}</p>
      </div>
      <div class="map-filters row" ref="elFilters">
        <!-- Filters > left -->
        <div v-bind:class="mode === 'tournees' ? 'col-sm-9 col-md-8' : 'col-sm-9 col-md-8'">
          <div class="row">
            <!-- For everyone -->
            <div class="form-group col-sm-3">
              <label>Date</label>
              <datepicker class="form-control" language="fr" v-model="state.map.filters.date"
                          v-on:input="search()"></datepicker>
            </div>
            <!-- Only for mode materiel -->
            <div class="form-group col-sm-3" v-if="map.filters.mode === 'materiel' && materiels">
              <label>Matériel</label>
              <select class="form-control" v-model="state.map.filters.idMateriel" v-on:change="filterTournee()">
                <option :value="''" v-if="state.map.filters.idMateriel !== ''">Tous</option>
                <option :value="''" v-if="state.map.filters.idMateriel === ''" selected>Tous</option>
                <option v-if="state.materiels.actif" v-for="mat in state.materiels.dataTournees" :value="mat.id">
                  {{ mat.nom }}
                </option>
                <option v-if="!state.materiels.actif" v-for="mat in state.materiels.dataRemontees" :value="mat.id">
                  {{ mat.nom }}
                </option>
              </select>
            </div>
            <!-- Only for mode anomalies -->
            <div class="form-group col-sm-3" v-if="map.filters.mode==='anomalie' && anomalieList">
              <label>Anomalies</label>
              <select class="form-control" v-model="map.filters.idAnomalie">
                <option value="">Toutes</option>
                <option v-for="(item, index) in anomalieList" :value="index">{{ item }}</option>
              </select>
            </div>
            <div class="form-group col-sm-3" v-if="map.filters.mode==='anomalie' && sacList">
              <label>Sacs</label>
              <select class="form-control" v-model="map.filters.idSac">
                <option value="">Tous</option>
                <option v-for="(item, index) in sacList" :value="index">{{ item }}</option>
              </select>
            </div>
            <div class="form-group col-sm-3" v-if="map.filters.mode==='anomalie' && evenementList">
              <label>Evenements</label>
              <select class="form-control" v-model="map.filters.idEvenement">
                <option value="">Tous</option>
                <option v-for="(item, index) in evenementList" :value="index">{{ item }}</option>
              </select>
            </div>

            <div class="form-group col-sm-3" style="margin-left:1%" v-if="map.filters.mode==='anomalie'">
              <toggle-button
                :value="this.$store.state.map.filters.filterPhoto"
                :sync="true"
                :labels="{checked: 'Avec Photo', unchecked: 'Avec Photo'}"
                :color="{checked: '#AADC14', unchecked: '#767C97'}"
                @change="filterPhoto"
                :height="35" :width="120"/>
            </div>
            <!-- For everyone -->
            <div class="form-group col-sm-3" v-if="state.materiels.actif">
              <toggle-button
                :value="this.$store.state.map.filters.infoWindows"
                :sync="true"
                :labels="{checked: 'Infobulles', unchecked: 'Infobulles'}"
                :color="{checked: '#AADC14', unchecked: '#767C97'}"
                @change="toggleInfowWindows"
                :height="35" :width="120"/>
            </div>
            <div class="form-group col-sm-3" v-if="!state.materiels.actif">
              <toggle-button
                :value="true"
                :sync="true"
                :labels="{checked: 'Remontées', unchecked: 'Tournées'}"
                :color="{checked: '#AADC14', unchecked: '#767C97'}"
                @change="switchToTournee"
                :height="35" :width="120"/>
            </div>
            <!-- Only for mode materiel : export de toutes les données du jours -->
            <div class="buttons col-sm-3" v-if="map.filters.mode === 'materiel' && state.materiels.actif">
              <label class="btn btn-default display-map"
                     style="pointer-events: none; background-color: #AADC14; color: #001051; font-weight: bold;">
                {{
                  (state.map.result && state.map.result.dataTournees) ? `${state.map.result.dataTournees.length} tournée${(state.map.result.dataTournees.length > 1) ? 's' : ''}` : `Aucune tournée`
                }}
              </label>
            </div>
          </div>
        </div>
        <!-- Mode select > right -->
        <div class="col-sm-3 col-md-2" v-bind:class="mode=='tournees' ? 'col-md-offset-2' : 'col-md-offset-2'">
          <div class="switch clearfix" v-bind:class="map.filters.mode" @click="switchMode()">
            <div class="materiel"></div>
            <div class="anomalie"></div>
          </div>
        </div>

      </div>

      <div class="info-tournee" v-if="!state.materiels.actif && state.map.filters.mode ==='materiel'">
        <div class="materiel">
          <div class="title">Materiel</div>
          <div>{{ state.map.infoTournee.idMateriel | materielTypeV2 }}</div>
          <div>{{ state.map.infoTournee.nomMateriel }}</div>
        </div>
        <div class="cantonnier">
          <div class="title">Cantonnier associé</div>
          <div>{{ state.map.infoTournee.cantonnier }}</div>
        </div>
        <div class="time">
          <div class="title">Durée du service</div>
          <div>{{ state.map.infoTournee.duree }}
          </div>
        </div>
      </div>
      <!--      l'intégration du cluster pour regrouper les points GPS pour le mode anomalie-->
      <div v-if="this.$store.state.map.filters.mode === 'anomalie'">
        <gmap-map
          ref="map"
          v-if="mounted"
          :center="center"
          :zoom=13
          map-type-id="roadmap"
          :options="{mapTypeControl: false}"
          :style="mapStyle"
          v-bind:class="mode"
          class="gMap">

          <!-- Affichage des markers s'il exist des résultats
                ET si on est pas en mode anomalies
                  OU si le marker symbolise bien un des événements sélectionnés dans le filtre -->
          <gmap-cluster>
            <gmap-marker
              v-if="filterAnomalies(d)"
              v-for="(d,i) in state.map.result.declarations"
              :key='i'
              :icon="{ 'url' : 'static/img/' + getPictoForDeclarations(d) + '.svg' }"
              :position="{ 'lat' : d.lat, 'lng' : d.lon }"
              :clickable="true"
              :show="true"
              @click="markerClick(d)"
              @mouseover="peakInfowindow()"
              @mouseout="showInfowindow(d)">

              <!-- Infowindow des événements en mode tournée et anomalies -->
              <gmap-info-window
                @closeclick="onInfowindowclose(d)"
                :opened="d.opened && map.filters.infoWindows">
                <div class="evenement ANOMALIE" v-if="!showPhotos">
                    <span>
                      {{ d.tournee_id | getMaterielFromDeclaration }}
                    </span>
                  <br>
                  <span>
                    {{ d | evenementType }}
                    <img @mouseover="showPhotosPopup()" src="static/img/btn_photo.svg" class="photo"
                         alt="Smiley"
                         v-if="d.photos.length > 0">
                  </span>
                  <strong v-if="d.nature === 'EVENEMENT'">
                    {{ d.commentaire }}
                  </strong>
                  <div class="time">à {{ d.recordedAt | prettyTimeStamp }}</div>
                  <div v-if="d.qr_code" class="qr-code">
                    <div class="title">QR Code</div>
                    <div>{{ d.qr_code }}</div>
                  </div>
                </div>
                <div class="photos" v-if="showPhotos">
                  <ul class="photos-list"
                      v-for="(photo ,i) in d.photos">

                    <li>
                      <router-link v-bind:to="'photo/' +photo.id"
                                   target="_blank">Photo {{ i + 1 }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </gmap-info-window>
            </gmap-marker>
          </gmap-cluster>
        </gmap-map>
      </div>

      <!--      la désactivation du cluster de regroupement des point GPS pour le mode materiel-->
      <div v-if="this.$store.state.map.filters.mode === 'materiel'">
        <gmap-map
          ref="map"
          v-if="mounted"
          :center="center"
          :zoom="13"
          map-type-id="roadmap"
          :options="{mapTypeControl: false}"
          :style="mapStyle"
          v-bind:class="mode"
          class="gMap">

          <!-- Affichage des markers s'il exist des résultats
                ET si on est pas en mode anomalies
                  OU si le marker symbolise bien un des événements sélectionnés dans le filtre -->
          <gmap-marker
            v-if="map.result !== null && map.result.tournees && map.result.tournees.length > 0"
            v-for="(t,i) in map.result.tournees"
            :key='i'
            :icon="{ 'url' : 'static/img/debut_de_service.svg' }"
            :position="{ 'lat' : t.latLastRemontee, 'lng' : t.lonLastRemontee }"
            :clickable="true"
            :show="false">

            <!-- Infowindow des points de début d'une tournée -->
            <gmap-info-window v-if="mode==='tournees'" :opened="map.filters.infoWindows"
                              :options="{ pixelOffset: { height: -5, width: 0}}">
              <div class="pointer">
                <div @click="setMateriel(t)">
                  <img class="top" v-bind:src="t.materiel_id | materielPictoV2"
                       v-bind:alt="t.materiel_id | materielTypeV2">
                  <div class="title">{{ t.materiel_id | materielTypeV2 }}</div>
                  {{ t.materiel_id | materielName }}
                  <div class="time">
                    <span v-if="t.statusTournee === 'TERMINEE'">Terminée à {{ t.endedAt | prettyDate }}</span>
                    <span v-if="t.statusTournee === 'EN COURS'">En cours</span>
                  </div>
                </div>
              </div>
            </gmap-info-window>

          </gmap-marker>

          <gmap-marker
            v-if="map.result !== null && state.map.result.remontees && state.map.result.remontees.length > 0"
            v-for="(r,i) in state.map.result.remontees"
            :key='i'
            :icon="{ 'url' : 'static/img/'+getPictoForRomontees(r)+'.svg' }"
            :position="{ 'lat' : r.lat, 'lng' : r.lon }"
            :clickable="false"
            :show="false">

          </gmap-marker>


        </gmap-map>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import {anomalieList, genreDisplayList, sacList, evenementList} from '../../const'
import $ from 'jquery'
import state from '../../store/state'
import {evenementType} from '../../filters'

export default {
  components: {
    Datepicker,
  },
  data: function () {
    return {
      mounted: false,
      infoWindowMode: '',
      currentMidx: null,
      showing: null,
      showPhotos: false,
    }
  },
  computed: {
    state () {
      return state
    },
    ...mapState([
      'map',
      'currentVille',
      'materiels'
    ]),
    mode: function () {
      if (this.$store && this.$store.state.map) {
        return this.$store.state.map.mode
      } else {
        return 'tournees'
      }
    },
    exportButtonVisible: function () {
      return this.mode === 'tournee'
    },
    center: function () {

      return {
        lat: this.$store.state.currentVille.coords.lat,
        lng: this.$store.state.currentVille.coords.lon
      }
    },
    zoom: function () {
      var map = this.$store.state.map
      if (map.result === null) {
        return 13
      } else if (!map.result.tournees || map.result.tournees.length === 0) {
        return 14
      } else {
        return 13
      }
    },
    mapStyle: function () {
      const h = document.body.clientHeight - (this.$refs.elFilters ? this.$refs.elFilters.clientHeight : 0) + 40
      return 'width: 100%; height: ' + h + 'px'
    },
  },
  updated: function () {
    this.smartRedraw('updated')
  },
  mounted: function () {
    this.mounted = true
    this.sacList = sacList()
    this.anomalieList = anomalieList()
    this.genreDisplayList = genreDisplayList()
    //  this.$store.dispatch('fetchMateriel')
    this.$store.dispatch('fetchMaterielsOfVille')
    this.$store.dispatch('fetchCantonniersOfVille')
    this.search()
    this.ongoingRedraw = false
    this.evenementList = evenementList()
  },
  methods: {
    showPhotosPopup: function () {
      this.showPhotos = !this.showPhotos
    },
    setMateriel: function (tournee) {
      this.showing = null
      this.$store.dispatch('setMapFilter', {filterKey: 'idTournee', value: tournee.id})
      this.$store.dispatch('setMapFilter', {filterKey: 'idMateriel', value: tournee.materiel_id})
      this.$store.dispatch('searchTournee', {filters: this.$store.state.map.filters})
      this.setInfoTournee(tournee.id)
    },
    setInfoTournee: function (idTournee) {
      this.$store.dispatch('searchInfoTournee', {idTournee: idTournee})

    },
    markerClick: function (marker) {
      if (this.$store.state.map.filters.mode === 'materiel') {
        this.setMateriel(marker.materiel)
      } else {
        marker.opened = !marker.opened

      }
    },
    filterAnomalies: function (marker) {
      console.log('deb-filter => ', this.map.filters)
      if (marker.type === this.map.filters.idSac.toUpperCase()) {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      } else if (marker.type === this.map.filters.idAnomalie.toUpperCase()) {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      } else if (marker.type === this.map.filters.idEvenement.toUpperCase()) {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      } else if (this.map.filters.idSac === '' && marker.nature === 'DEPOT_SAC') {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      } else if (this.map.filters.idAnomalie === '' && marker.nature === 'ANOMALIE') {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      } else if (this.map.filters.idEvenement === '' && marker.nature === 'EVENEMENT') {
        if (this.map.filters.filterPhoto && marker.photos.length === 0) {
          return false
        }
        return true
      }
    },
    getPictoForRomontees: function (marker) {
      var ico
      if (marker.typeRemonteeGPS === 'SUIVI_GPS') {
        ico = 'marker'
      } else if (marker.typeRemonteeGPS === 'FIN_DE_SECTEUR') {
        ico = 'geoend'
      } else if (marker.typeRemonteeGPS === 'DEBUT_DE_SECTEUR') {
        ico = 'geostart'
      } else if (marker.typeRemonteeGPS === 'DEBUT_DE_SERVICE') {
        ico = 'debut_de_service'
      } else if (marker.typeRemonteeGPS === 'FIN_DE_SERVICE') {
        ico = 'fin_de_service'
      } else {
        ico = 'pause_pastille_rouge'
      }
      ico = ico.toLowerCase()
      return ico
    },
    getPictoForDeclarations: function (marker) {
      var ico

      if (marker.nature === 'EVENEMENT') {
        ico = 'evenement_icon'
      } else {
        ico = 'anomalie-' + marker.type
        if (marker.type.toLowerCase().indexOf('debordement') === -1 && marker.detailType && marker.detailType !== '') {
          ico += '_' + marker.detailType
          if (marker.etat && marker.etat !== '' && marker.detailType.toLowerCase() !== 'plaque_egout' && marker.detailType.toLowerCase() !== 'tableau_electrique') {
            ico += '_' + marker.etat
          }
        }
      }
      ico = ico.toLowerCase()
      console.log('marker =============================> ', marker)
      console.log('ico =============================> ', ico)
      return ico
    },
    search: function () {
      if (this.$store.state.map.filters.mode === 'materiel') {
        console.log('ifff')
        this.$store.dispatch('searchTournees', {filters: this.$store.state.map.filters})
      } else {
        console.log('elseeeee')
        this.$store.dispatch('searchDeclarations', {filters: this.$store.state.map.filters})
      }
    },
    filterTournee: function () {
      if (!this.state.materiels.actif) { // Si on est dans l'affichage des remontées GPS d'une tournée le changement du matériel (la selection du choix tous) devra nous rediriger dans l'affichage des tournées du jour
        this.$store.dispatch('searchTournees', {filters: this.$store.state.map.filters})
      } else { // Si on est dans l'affichage des tournées le changement du matériel un filtre sur les tournées va s'effectuer pour garder que les tournées réalisées avec le matériel choisi
        this.$store.dispatch('filterTournees', {filters: this.$store.state.map.filters})
      }
    },
    switchToTournee: function () {
      state.materiels.actif = true
      state.map.result.remontees = []
      this.$store.dispatch('filterTournees', {filters: this.$store.state.map.filters})
    },
    showInfowindow: function (d) {
      if (d.photos.length > 0) {
        return
      }
      if (this.showPhotos) {
        this.showPhotos = !this.showPhotos
        return
      }
      d.opened = false
    },
    onInfowindowclose: function (d) {
      d.opened = false
    },
    peakInfowindow: function () {
      this.showPhotos = false
    },
    switchMode: function () {
      this.$store.state.map.filters.mode = (this.$store.state.map.filters.mode === 'materiel' ? 'anomalie' : 'materiel')

      if (this.$store.state.map.filters.mode === 'materiel') {
        this.$store.state.map.result.remontees = []
        this.$store.dispatch('searchTournees', {filters: this.$store.state.map.filters})
      } else {
        this.$store.state.map.result.declarations = []
        this.$store.dispatch('searchDeclarations', {filters: this.$store.state.map.filters})
      }
      this.$store.state.map.filters.infoWindows = true
    },
    toggleInfowWindows: function (event) {
      this.$store.state.map.filters.infoWindows = event.value
    },
    filterPhoto: function (event) {
      this.$store.state.map.filters.filterPhoto = event.value
    },
    exportize: function () {
      this.$store.dispatch('generateReporting', {
        daysList: [
          this.$store.state.map.filters.date,
        ],
        idsMateriel: [
          this.$store.state.map.filters.idMateriel,
        ],
      })
    },
    smartRedraw: function () {
      var $t = this
      var start = null
      var startMemo = null
      this.req = window.requestAnimationFrame(step)

      function step (timestamp) {
        var progress, total
        if (startMemo === null) {
          startMemo = timestamp
        }
        if (start === null) {
          start = timestamp
          if (state.map.result.declarations.length > 0) {
            $t.redraw()
          } else {
            window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
            window.cancelAnimationFrame($t.req)
            return
          }
        }
        $t.req = window.requestAnimationFrame(step)
        progress = timestamp - start
        total = timestamp - startMemo

        if (total >= 50000) {
          window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
          window.cancelAnimationFrame($t.req)
        } else if (progress >= 1000) {
          start = null
        }
      }
    },
    redraw: function () {
      if (this.ongoingRedraw) {
        return false
      }
      this.ongoingRedraw = true

      var iwOuter = $(this.$refs.gMapWrapper).find('.gMap .gm-style-iw')
      iwOuter.each(function (index, element) {
        var e = $(element)
        var b = e.prev()

        if (!e.hasClass('done')) {
          /* The DIV we want to change is above the .gm-style-iw DIV.
           * So, we use jQuery and create a iwBackground variable,
           * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
           */
          // Remove the background shadow DIV
          b.children(':nth-child(2)').css({'display': 'none'})

          // Remove the white background DIV
          b.children(':nth-child(4)').css({'display': 'none'})

          b.children(':nth-child(3)').find('div').children().css({
            'z-index': '100',
            'box-shadow': '0 4px 4px 0 rgba(0, 0, 0, 0.3)',
          })

          e.css({
            'background-color': '#FFF',
            'color': 'inherit',
          })
          b.children(':nth-child(3)').find('div').children().css({
            'background-color': '#FFF',
          })
          if (e.find('.evenement.ANOMALIE').length > 0) {
            e.css({
              'background-color': '#2e45ad',
            })
            b.children(':nth-child(3)').find('div').children().css({
              'background-color': '#2e45ad',
            })
          } else if (e.find('.evenement.DEPOT_SAC').length > 0) {
            e.css({
              'background-color': '#767c97',
            })
            b.children(':nth-child(3)').find('div').children().css({
              'background-color': '#767c97',
            })
          }

          var iwCloseBtn = e.next()
          iwCloseBtn.css({display: 'none'})

          e.addClass('done')
        }
      })

      this.ongoingRedraw = false
      window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
      window.cancelAnimationFrame(this.req)
    }
  }

}
</script>

<style lang="scss">

@import '../../scss/variables';

.gm-style-iw-tc {
  display: none;
}

.vue-map-container .vue-map {
  margin-top: 100px;
}

.callout {
  margin: 15px;
}

.map-wrapper {
  position: relative;

  .row {
    background-color: transparent;
    overflow: visible;
    flex-flow: row wrap;
  }

  .map-filters {
    position: absolute;
    z-index: 1000;
    width: 100%;
    background-color: #ffffff;

    & > div {
      vertical-align: top;
    }

    .row {
      margin: 0 -15px;
      border-radius: 0 0 5px 0;
      background-color: rgba(255, 255, 255, 0.8);
      padding: 20px 15px;

      & > div + div {
        padding-left: 0
      }
    }

    .form-group {
      margin-bottom: 0;
    }

    .form-control {
      width: 100%;
      display: inline-block;
    }

    label {
      display: block;
    }

    .buttons {
      display: inline-block;
      vertical-align: top;

      @media screen and (min-width: 768px) {
        margin-top: 23px;
      }
      @media screen and (max-width: 767px) {
        margin-bottom: 20px;
      }

      button {
        background-color: $suez-blue;
        background-image: url('/static/img/icon-dl.svg');
        background-repeat: no-repeat;
        background-position: 15px center;
        color: white;
        font-size: 14px;
        font-weight: bold;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border: none;
        padding: 7px 15px 8px 45px;
      }
    }

    .vdp-datepicker.form-control {
      -webkit-appearance: menulist-button;
      -moz-appearance: menulist-button;
      appearance: menulist-button;
      padding: 0;
      margin: 0;

      input {
        border: none !important;
        padding: 5px;
        width: 95%;
        margin: 2px;
        background: none;
      }
    }

    .vdp-datepicker.form-control, select {
      background-color: $suez-green-yellowish;
      color: $suez-blue;
      border: none;
      font: 14px/22px 'DinMedium';
    }

    label.vue-js-switch {
      font-size: 14px;
      display: inline-block;
      margin: 23px 0 0 0;

      .v-switch-label {
        color: $suez-blue;
        font-weight: normal;
        font-family: 'DinMedium';
      }
    }

    .switch {
      width: 100px;
      height: 54px;
      border-radius: 100px;
      background-color: #001051;
      box-shadow: 0 2px 4px 0 rgba(168, 168, 168, 0.2);
      cursor: pointer;
      float: right;

      div {
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center center;
        margin: 3px;
      }

      @mixin on() {
        width: 48px;
        height: 48px;
        border-radius: 40px;
        background-color: #ffffff;
        z-index: 1;
      }
      @mixin off() {
        width: 35px;
        height: 48px;
        border-radius: 40px;
        z-index: 5;
      }

      &.anomalie {
        .materiel {
          background-image: url('/static/img/switch-materiel-off.svg');
          @include off();
        }

        .anomalie {
          background-image: url('/static/img/switch-anomalie-on.svg');
          @include on();
          margin-left: 5px;
          margin-right: 0;
        }
      }

      &.materiel {
        .materiel {
          @include on();
          background-image: url('/static/img/switch-materiel-on.svg');
        }

        .anomalie {
          background-image: url('/static/img/switch-anomalie-off.svg');
          @include off();
          margin-left: -1px;
        }
      }
    }

    @media screen and (max-width: 767px) {
      position: relative;
      z-index: 1;

      & > div, .row > div {
        display: block;
        float: none;
        clear: both;
        width: 100%;
        padding-left: 15px !important;
      }
      .row {
        background: none;
        padding-bottom: 0;
      }
      .form-group {
        padding-bottom: 15px;
      }
      label.vue-js-switch {
        margin-top: 0;
      }
      .switch {
        float: none;
        margin-left: 15px;
        margin-bottom: 20px;
      }
    }
  }
}

.content.map {
  height: 100%;
}

.info-tournee {
  position: absolute;
  z-index: 10;
  top: 140px;
  left: 30px;
  background-color: white;
  padding: 20px;
  color: $suez-blue;
  font: 18px/21px 'DinCondRegular';
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(168, 168, 168, 0.5);

  & > div {
    background-repeat: no-repeat;
    padding-left: 40px;

    & + div {
      margin-top: 15px
    }

    .title {
      font-family: 'DinCondMedium';
    }

    &.materiel {
      background-image: url('/static/img/recap-materiel.svg');
    }

    &.cantonnier {
      background-image: url('/static/img/recap-cantonnier.svg');
    }

    &.time {
      background-image: url('/static/img/recap-duree.svg');
    }

    &.secteur {
      background-image: url('/static/img/fin_de_service.svg');
    }
  }
}

.gMap .gm-style .gm-style-iw-d {
  overflow: hidden !important;
  padding: 0px 5px 10px !important;
}

.gMap .gm-style .gm-style-iw {
  overflow: visible;
  min-width: 150px !important;
  max-width: 300px !important;
  border-radius: 4px;
  background-color: white;
  overflow: visible !important;
  margin-top: 5px;
  padding: 15px 0 5px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);

  .tournee, .evenement {
    &, .time {
      font-size: 14px !important;
      line-height: 19px;
    }
  }

  .photo {
    border-radius: 20px;
    height: 20px;
    width: 20px;
    display: inline-block;

    img {
      max-width: 60%;
      margin-top: -5px;
    }
  }

  .ANOMALIE .photo {
    background-color: $suez-sapphire;
  }

  .DEPOT_SAC .photo {
    background-color: $suez-steel;
  }

  .evenement, .evenement .fa-close {
    color: white !important;
  }

  .fa-close {
    position: absolute;
    font-size: 14px;
    right: 8px;
    top: 7px;
    color: #999;
    cursor: pointer;
  }

  .gm-ui-hover-effect {
    opacity: 1 !important;
  }

  .photos {
    background: white !important;
    background-color: white !important;
  }

  .photos.gm-style-iw-d.gm-style-iw {
    background-color: #ffffff !important;
  }

  ul.photos-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
}

</style>



// WEBPACK FOOTER //
// Map.vue?12018645